import styled from 'styled-components';

import { Breakpoint, Color, FontWeight } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { ArtworkTable } from '../artworkTable/artworkTable.component';
import { CircleBadges } from '../circleBadges/circleBadges.component';
import { Image } from '../image/image.component';
import { InformationBox } from '../informationBox/informationBox.component';
import { Markdown } from '../markdown/markdown.component';

export const Container: StyledComponent<'div'> = styled.div`
  display: flex;
  width: 100%;

  @media ${Breakpoint.Mobile} {
    flex-direction: column;
  }
`;

export const LeftSection: StyledComponent<'div'> = styled.div`
  width: calc(50% - 40px);
  margin-right: 40px;

  @media ${Breakpoint.Mobile} {
    width: 100%;
  }
`;

export const RightSection: StyledComponent<'div'> = styled.div`
  width: 50%;

  @media ${Breakpoint.Mobile} {
    width: 100%;
  }
`;

export const Title: StyledComponent<'div'> = styled.div`
  font-weight: ${FontWeight.Medium};
  font-size: 22px;
  line-height: 28px;
  letter-spacing: -0.01em;

  @media ${Breakpoint.Mobile} {
    margin-bottom: 32px;
  }
`;

export const Description: StyledComponent<typeof Markdown> = styled(Markdown)`
  p {
    font-weight: ${FontWeight.Light};
    font-size: 18px;
    line-height: 26px;
    color: ${Color.Black};

    & + p {
      margin-top: 20px;
    }
  }
`;

export const ImagesContainer: StyledComponent<'div'> = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 40px;
`;

export const ImageElement: StyledComponent<typeof Image> = styled(Image)`
  width: 100%;
  height: auto;

  & + & {
    margin-top: 20px;
  }
`;

export const StyledArtworkTable: StyledComponent<typeof ArtworkTable> = styled(ArtworkTable)``;

export const StyledCircleBadges: StyledComponent<typeof CircleBadges> = styled(CircleBadges)``;

export const DescriptionContainer: StyledComponent<'div'> = styled.div`
  transition: all 0.3s ease-in-out;

  & + ${StyledCircleBadges},
  & + ${StyledArtworkTable} {
    margin-top: 40px;
  }
`;

export const StyledInformationBox: StyledComponent<typeof InformationBox> = styled(InformationBox)`
  & + ${DescriptionContainer},
  & + ${StyledCircleBadges},
  & + ${StyledArtworkTable} {
    margin-top: 40px;
  }
`;

export const LinkButton: StyledComponent<'button'> = styled.button.attrs({ type: 'button' })`
  font-weight: ${FontWeight.Medium};
  font-size: 18px;
  line-height: 26px;
  text-decoration-line: underline;
  color: ${Color.Black};
  margin-top: 20px;
`;
